/* eslint-disable ember/no-computed-properties-in-native-classes */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { filterBy } from '@ember/object/computed';
import { service } from '@ember/service';
import GroupType from '@linc-technologies/linced-common/enums/group-type';
import moment from 'moment';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';

export default class GroupsController extends Controller {
  @action
  setYear(value) {
    this.year = value;
  }

  queryParams = ['year'];

  @service
  session;

  @service
  options;

  @service
  permissions;

  @service
  strings;

  PersonType = PersonType;
  @tracked year = moment().year();
  @tracked currentYear = moment().year();
  @optionAlias('core:groups:groupings')
  groupings;

  @filterBy('groupings', 'value')
  cleanGroupings;

  @filterBy('model.groups', 'type', GroupType.HOMEROOM)
  homeroomGroups;

  @filterBy('model.groups', 'type', GroupType.GROUP)
  myGroups;

  @filterBy('model.groups', 'type', GroupType.SHARED)
  sharedGroups;

  @computed('homeroomGroups.length', 'myGroups.length', 'sharedGroups.length')
  get hasNoGroups() {
    let numHomeroom = this.homeroomGroups.length;
    let numMy = this.myGroups.length;
    let numShared = this.sharedGroups.length;

    return numHomeroom + numMy + numShared === 0;
  }

  @optionAlias('core:staffPermissions:hideNextYearsPlacementsForTeachers')
  hideNextYearsPlacementsForTeachers;

  @computed('session.scopes.[]')
  get hasAdminAccess() {
    return this.permissions.meet(Scopes.TENANT_ADMIN);
  }

  @computed(
    'hasAdminAccess',
    'hideNextYearsPlacementsForTeachers',
    'year',
    'currentYear',
  )
  get disableNextYear() {
    if (this.year > this.currentYear) {
      return true;
    }
    if (this.year === this.currentYear) {
      return !this.hasAdminAccess && this.hideNextYearsPlacementsForTeachers;
    }
    return false;
  }

  @action
  onDelete() {
    this.model.groups.update();
  }
}
